import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // Use localStorage for React
import rootReducer from './reducers/index';

// Redux Persist configuration
const persistConfig = {
  key: 'root',
  storage, // Use redux-persist's localStorage
  whitelist: [
    'showIntroReducer',
    'userTokenReducer',
    'loginDetailReducer',
    'userDetailReducer',
    'coinDetailReducer',
    'resultDetailReducer',
    'languageReducer',
    'OpenDrawerReducer',
  ],
};

// Persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configure the Redux store
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore redux-persist actions as they involve non-serializable data
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
      // serializableCheck: false, // Avoid serializable warning
    }),
});

// Create the persistor
export const persistor = persistStore(store);

export default store;
